module.exports = __webpack_public_path__ + "img/password.5fb76a71.png";